import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import RadioSwitch from 'tradera-components/form-controls/radio-switch';

const ContentSwitch = props => {
    const { className, defaultSelected, onSwitch, options, title } = props;
    const [selected, setSelected] = useState(
        defaultSelected || Object.keys(options)[0]
    );
    // Keep track of which options have been shown to only render what's needed
    const [renderedOptions, setRenderedOptions] = useState([selected]);
    const onChange = useCallback(
        selected => {
            if (!renderedOptions.includes(selected)) {
                setRenderedOptions([...renderedOptions, selected]);
            }
            setSelected(selected);
            if (onSwitch) onSwitch(selected);
        },
        [onSwitch, renderedOptions, setRenderedOptions, setSelected]
    );

    return (
        <section className={className}>
            <div className="d-flex justify-content mb-1 mb-md-2">
                {title && (
                    <h3 className="start-page-section-title flex-grow-1 mb-0 align-self-center">
                        {title}
                    </h3>
                )}
                <div
                    style={{ maxWidth: '25rem' }}
                    className="flex-grow-1 ml-0 ml-lg-3 ml-xl-2 mr-2 mr-md-3 mr-lg-2 mr-xl-1 my-auto text-nowrap">
                    <RadioSwitch
                        id={'radio-switch-1'}
                        options={Object.keys(options).map(key => ({
                            value: key,
                            name: options[key].label
                        }))}
                        checked={selected}
                        handleOnChange={onChange}
                    />
                </div>
            </div>
            {Object.entries(options).map(([key, option]) => (
                <div
                    key={key}
                    className={`${
                        key === selected
                            ? 'd-block pl-lg-2 pl-xl-1 mr-xl-n1'
                            : 'd-none'
                    }`}>
                    {renderedOptions.includes(key) ? option.node : null}
                </div>
            ))}
        </section>
    );
};

ContentSwitch.propTypes = {
    defaultSelected: PropTypes.string,
    onSwitch: PropTypes.func,
    options: PropTypes.objectOf(
        PropTypes.shape({
            label: PropTypes.node.isRequired,
            node: PropTypes.node.isRequired
        })
    ).isRequired,
    title: PropTypes.string
};

ContentSwitch.defaultProps = {
    lazyLoad: true
};

export default ContentSwitch;
